export const title = 'Already have an account?';
export const blurb =
  'If you have an existing account, you can sign in to get access to this webinar right away!';
export const link = 'Log In';
